<template>
  <base-section-layout
    title="EMS 护照邮寄在线付款流程"
    icon="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-www/order/order-interview-notification/section-ems.png"
  >
    <div class="payment-block">
      <div class="payment-title">付款流程</div>
      <div class="payment-content">
        <div class="step-item">
          1. 第一步：登录 https://vfs.gtspremium.com 输入预约单上的
          UID（预约单上的条形码下面）
        </div>
        <div class="step-item">
          2. 第二步：选择【预约时的领馆，哪里递交就选择哪里】
        </div>
        <div class="step-item">3. 第三步：选择【护照返还】</div>
        <div class="step-item">4. 第四步：填写【姓氏拼音】→下一步</div>
        <div class="step-item">5. 第五步：填写【中文收件人信息】→下一步</div>
        <div class="step-item">
          6. 第六步：核对 UID 信息+支付费用点击【下一步】
        </div>
        <div class="step-item">
          7. 第七步：选择支付方式→确认扫码支付即可完成
        </div>
      </div>
    </div>

    <div class="payment-block">
      <div class="payment-title">重要提醒</div>
      <div class="payment-content">
        <div class="step-item">
          1. 缴费时限：邮寄服务费用建议在您<span class="c-red"
            >面签后48小时内完成支付</span
          >。如未在领馆规定时间内完成支付，护照将暂存于领事馆，届时需自行前往领取，领取护照周期预计延长3–4周，可能对出行计划造成影响。
        </div>
        <div class="step-item">
          2. 地址确认：<span class="c-red">收件地址提交后无法修改</span
          >，请务必反复核对确保准确无误，避免因地址错误导致派送失败或延误处理时间。
        </div>
      </div>
    </div>
  </base-section-layout>
</template>

<script>
import BaseSectionLayout from './BaseSectionLayout.vue';

export default {
  name: 'SectionEmsPayment',
  components: {
    BaseSectionLayout,
  },
};
</script>

<style lang="less" scoped>
.payment-block {
  padding: 16px 0;
  border-bottom: 0.5px solid #e9eef2;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }

  .payment-title {
    margin-bottom: 8px;
    color: #333;
    font-size: 13px;
    font-weight: 500;
    line-height: 22px;
  }

  .payment-content {
    color: #666;
    font-size: 12px;
    line-height: 21px;
  }

  .step-item {
    margin-bottom: 8px;
    word-break: break-all;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .c-red {
    color: #ff4b4d;
  }
}
</style>
